<div class="navbar-area border-b relative z-10 py-[20px] lg:py-[25px] xl:py-0">
    <div class="mx-auto px-[12px] sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1920px] 2xl:px-[30px] 3xl:px-[120px]">
        <nav class="navbar relative flex flex-wrap">

            <!-- LOGO SECTION -->
            <div class="self-center">
                <a routerLink="/">
                    <img [src]="logoGov"
                        class="inline w-auto h-[6vh] sm:h-[10vh] xl:h-[8vh] 3xl:h-[130px] 3xl:py-[15px]"
                        alt="logo">
                </a>
            </div>

            <!-- MOBILE MENU BUTTON -->
            <button class="navbar-toggler absolute ml-auto right-0 top-[4px] xl:hidden"
                    type="button"
                    (click)="toggleClass()">
                <span class="burger-menu text-black cursor-pointer leading-none text-[30px]">
                    <i class="ri-menu-line"></i>
                </span>
            </button>

            <!-- NAVBAR CONTENT -->
            <div class="navbar-collapse flex self-center grow basis-auto" id="targetElement">

                <!-- DESKTOP MENU -->
                <ul class="navbar-nav self-center flex-row ml-auto hidden xl:flex">
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0">
                        <a routerLink="/inicio"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-verde1">
                            {{ texts?.home }}
                        </a>
                    </li>
                    <li class="xl:mx-[10px] 2xl:mx-[18px] py-[10px] lg:py-[15px] xl:py-[35px] 2xl:py-[41.5px] relative group last:mr-0 first:ml-0">
                        <a routerLink="/chat-tasa"
                           class="text-black uppercase text-[14px] 3xl:text-[20px] font-medium transition-all hover:text-verde1">
                            Chat Tasa
                        </a>
                    </li>
                </ul>

                <!-- MOBILE MENU -->
                <div class="xl:hidden mobile-menu">
                    <div class="mobile-menu-items">
                        <a routerLink="/inicio"
                           class="mobile-menu-item block py-3 px-4 text-black"
                           (click)="toggleClass()">
                            {{ texts?.home }}
                        </a>
                        <a routerLink="/chat-tasa"
                           class="mobile-menu-item block py-3 px-4 text-black"
                           (click)="toggleClass()">
                            Chat Tasa
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</div>